import React, { useCallback, useRef, useState } from 'react';
import { ConfirmDialog } from '@shared/components/confirmDialog/ConfirmDialog';
import { useBlocker } from './useBlocker';

type Params = {
  isBlocked: boolean;
  titleKey: string;
  message: string;
};

export const RouterBlockerDialog: React.FC<Params> = ({ isBlocked, titleKey, message }) => {
  const [showDialog, setShowDialog] = useState(false);
  const resolveRef = useRef<((proceed: boolean) => void) | null>(null);

  const confirmAsync = useCallback(() => {
    return new Promise<boolean>((resolve) => {
      resolveRef.current = resolve;
      setShowDialog(true);
    });
  }, []);

  useBlocker(isBlocked, message, confirmAsync);

  const finish = useCallback((proceed: boolean) => {
    setShowDialog(false);
    resolveRef.current?.(proceed);
    resolveRef.current = null;
  }, []);

  return (
    <ConfirmDialog
      showDialogFlag={showDialog}
      handleClose={() => finish(false)}
      dialogTitle={titleKey}
      dialogContentText={message}
      showDialog={() => finish(false)}
      confirmDialog={() => finish(true)}
      variant="warning"
    />
  );
};
